// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"853":"67e4a6b6","980":"f2d2928d"}[chunkId] + ".chunk.js";
};